import React from "react";
import StyledModalContainer from "./styles";

const CustomAlert = ({ children }) => {
  return (
    <StyledModalContainer>
      <div className="portal-wrapper">
        <div className="portal-sticky">{children}</div>
      </div>
    </StyledModalContainer>
  );
};

export default CustomAlert;
